'use client';

import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { keywordsRankingsOptions } from '~/app/search/_queries';

import { RollingDisplay, HomeRankedKeywordsTitle, AccordionArea } from '~/app/(home)/_components';
import { RankedKeywords, Spacing } from '~/components';
import { KeywordsRanking } from '~/apis/mercari/get-keywords-rankings';
import { useEnvironmentInfo, useSendLog } from '~/hooks';
import { goToFullWebviewOnApp } from '~/services/app-interface';
import { BUTTON_ID, EVENT_ACTION, EVENT_TYPE, PAGE_ID } from '~/apis/log/constant';
import { AnimatePresence } from 'motion/react';

export const HomeRankedKeywords = () => {
  const sendLog = useSendLog();
  const { isWebview } = useEnvironmentInfo();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const { data: keywords } = useQuery(keywordsRankingsOptions({ size: 10 }));

  const handleKeywordClick = (value: KeywordsRanking, index?: number) => {
    sendLog({
      event_type: EVENT_TYPE.SELECT,
      event_action: EVENT_ACTION.SELECT_BUTTON,
      page_id: PAGE_ID.HOME,
      button_id: BUTTON_ID.RANKED_KEYWORD,
      button_label: value.keyword,
      button_position: index,
    });
    const path = `/search/result?q=${value.keyword}`;
    const url = isWebview ? process.env.NEXT_PUBLIC_DOMAIN + path : path;
    isWebview ? goToFullWebviewOnApp({ url }).go() : globalThis.window.open(url, '_blank');
  };

  if (!keywords || keywords?.length < 1) return null;

  return (
    <>
      {isExpanded ? (
        <HomeRankedKeywordsTitle onArrowClick={() => setIsExpanded(false)} />
      ) : (
        <RollingDisplay
          keywords={keywords}
          onKeywordClick={handleKeywordClick}
          onArrowClick={() => setIsExpanded(true)}
        />
      )}

      <AnimatePresence>
        {isExpanded && (
          <AccordionArea>
            <Spacing height={20} />
            <RankedKeywords rankedKeywords={keywords} onKeywordClick={handleKeywordClick} />
            <Spacing height={20} />
          </AccordionArea>
        )}
      </AnimatePresence>
    </>
  );
};
